import { h, Component, render } from "preact";
import { Connect, Provider } from "redux-zero/preact";
import { store } from "./store";
import actions from "./actions";

class CartCount extends Component {
  constructor(props) {
    super(props);
  }
  
  componentDidMount() {
    if (this.props.cart !== {}) {
      this.props.getCart();
    }
  }
  
  renderCount() {
    return (
      <span className="header__cart-btn__num">
        { this.props.item_count }
      </span>
    )
  }
  handleToggleMinicart(e) {
    e.preventDefault();
    if (window.innerWidth <= 1199) {
      location.href = '/cart';
      return;
    }
    this.props.toggleMinicart(e)
  }
  
  render({item_count, toggleMinicart}) {
    return (
      <a href="/cart" className="header__btn header__cart-btn" onClick={ (e) => {this.handleToggleMinicart(e)} }>
        <svg class="{{ icon_class }}" role="img" aria-label="Icon Cart" width="26" height="26" viewBox="0 0 26 26"
             fill="none" xmlns="http://www.w3.org/2000/svg">
          <desc>Icon Cart</desc>
          <path d="M6.0625 6.1579H20.9375L22 23H5L6.0625 6.1579Z" stroke="currentColor" stroke-width="2"/>
          <path d="M18 7C18 4.23858 15.9853 2 13.5 2C11.0147 2 9 4.23858 9 7" stroke="currentColor" stroke-width="2"/>
          <path d="M18 7V10" stroke="currentColor" stroke-width="2"/>
          <path d="M9 7V10" stroke="currentColor" stroke-width="2"/>
        </svg>
        { item_count > 0 ? this.renderCount() : '' }
      </a>
    )
  }
  
}

const ref = document.querySelector('[data-cart-count]');
if (ref) {
  render(
    <Provider store={ store }>
      <Connect actions={ actions }>
        { ({item_count, cart, getCart, toggleMinicart}) => (
          <CartCount item_count={ item_count } cart={ cart } getCart={ getCart } toggleMinicart={ toggleMinicart }/>
        ) }
      </Connect>
    </Provider>, ref, ref.querySelector('a')
  )
}
